"use client";

import { useRef } from "react";
import { ArrowUpRight, Play } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Industrysolutionshero() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".pf-kit", {
        rotate: -8,
        transformOrigin: "50% 60%"
      });
      gsap.to(".pf-kit", {
        rotate: 0,
        duration: 1.0,
        ease: "power3.out"
      });
      gsap.to(".pf-halo", {
        opacity: 1,
        duration: 0.9,
        ease: "power2.out"
      });
      gsap.set(".pf-eyebrow", {
        y: 12
      });
      gsap.to(".pf-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        delay: 0.15,
        ease: "power3.out"
      });
      gsap.set(".pf-headline", {
        y: 24
      });
      gsap.to(".pf-headline", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        delay: 0.2,
        ease: "power3.out"
      });
      gsap.set(".pf-panel", {
        y: 20,
        filter: "blur(8px)"
      });
      gsap.to(".pf-panel", {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.75,
        delay: 0.4,
        ease: "power3.out"
      });
      gsap.to(".pf-halo", {
        scale: 1.04,
        opacity: 0.92,
        duration: 6,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
        delay: 1.2
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".pf-eyebrow", ".pf-headline", ".pf-panel", ".pf-halo"], {
        opacity: 1,
        y: 0,
        rotate: 0,
        filter: "none"
      });
    });
  }, {
    scope: container
  });
  return;
}